import _searchExtensions from "@fuze/apis-foundry/dist/extensions/functions/searchExtensions"
import _getExtensionBehaviour from "@fuze/apis-foundry/dist/extensions/functions/getExtensionBehaviour"
import _setExtensionBehaviour from "@fuze/apis-foundry/dist/extensions/functions/setExtensionBehaviour"

import { wrapFoundryFunction, wrapAllResultsNoOrganization } from "./decorators"

export const getExtensionBehaviour = wrapFoundryFunction(_getExtensionBehaviour)
export const setExtensionBehaviour = wrapFoundryFunction(_setExtensionBehaviour)
export const searchExtensions = wrapAllResultsNoOrganization(_searchExtensions)
